"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _locales = _interopRequireDefault(require("../locales.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Controls = function Controls(_ref) {
  var children = _ref.children,
      locale = _ref.locale,
      search = _ref.search,
      onSearchChange = _ref.onSearchChange,
      updateTable = _ref.updateTable;
  return _react["default"].createElement("div", {
    className: "controls"
  }, _react["default"].createElement("div", {
    className: "left"
  }, children), _react["default"].createElement("div", {
    className: "right"
  }, _react["default"].createElement("div", {
    className: "form-group"
  }, _react["default"].createElement("input", {
    type: "text",
    id: "search",
    name: "search",
    className: "form-control",
    placeholder: _locales["default"][locale]['table-input-search'],
    value: search,
    onChange: onSearchChange,
    onClick: function onClick(e) {
      return e.target.select();
    }
  })), _react["default"].createElement("button", {
    type: "button",
    id: "wafotable-reload",
    className: "btn btn-sm btn-light",
    onClick: updateTable
  }, _locales["default"][locale]['table-button-reload'])));
};

Controls.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  locale: _propTypes["default"].string,
  search: _propTypes["default"].string,
  onSearchChange: _propTypes["default"].func,
  updateTable: _propTypes["default"].func
};
Controls.defaultProps = {
  children: null,
  locale: 'en',
  search: '',
  onSearchChange: function onSearchChange(f) {
    return f;
  },
  updateTable: function updateTable(f) {
    return f;
  }
};
var _default = Controls;
exports["default"] = _default;